import lauHomecook from './brands/lau-homecook.json';
import louFoTong from './brands/lou-fo-tong.json';

const brands = {
  [lauHomecook.id]: lauHomecook,
  [louFoTong.id]: louFoTong
};

const brandId = process.env.REACT_APP_GUSTO_BRAND || lauHomecook.id;
const brand = brands[brandId];

if (!brand) {
  throw new Error(`Unknown REACT_APP_GUSTO_BRAND "${brandId}"`);
}

export default brand;
